import { createAction } from 'redux-actions';

import * as CONST from '../../constants';

export const updateFilterData = createAction(CONST.UPDATE_FILTER_DATA);
export const resetFilterData = createAction(CONST.RESET_FILTER_DATA);
export const setDefaultFilterData = createAction(CONST.SET_DEFAULT_FILTER_DATA);
